import { MathUtils, notUndef } from "shared-ts-utils-core";
import { merge } from "lodash";
import { BarSeriesType, LineSeriesType } from "@mui/x-charts-premium";
import { TimeSeries } from "firefly-shared-ts-timeseries";
import { MuiTimeSeriesOptions } from "./TimeSeriesMuiChart";
import { AllSeriesType } from "@mui/x-charts/models";
import { MakeOptional } from "shared-ts-mui";

export const resolveSeries = (
  timeSeries: Array<TimeSeries<number | null>>,
  timeSeriesOptions?: Array<MuiTimeSeriesOptions>
): Array<AllSeriesType<"line">> => {
  return timeSeries.map((series, seriesIndex) => {
    const seriesOptions = notUndef(timeSeriesOptions, (timeSeriesOptions) =>
      timeSeriesOptions.length >= seriesIndex - 1
        ? timeSeriesOptions[seriesIndex]
        : timeSeriesOptions[0]
    );
    const defaultOptions: AllSeriesType<"line"> = merge(
      {
        type: "line",
        showMark: false,
        data: series.points.map((point) => point.value),
        valueFormatter: (value: number | null) => {
          let formatted = "";
          if (value != null) {
            formatted += MathUtils.round(value);
          }
          if (series.info.unit != null) {
            formatted += " " + series.info.unit;
          }
          return formatted;
        },
      },
      seriesOptions
    );
    const options:
      | MakeOptional<LineSeriesType, "type">
      | MakeOptional<BarSeriesType, "type">
      | undefined = timeSeriesOptions?.[seriesIndex];

    return merge(defaultOptions, options);
  });
};
